import React from 'react';
import { WelcomeScreenUserMenu } from './WelcomeScreenUserMenu';
import './WelcomeScreenTitleBar.css';

interface WelcomeScreenTitleBarProps {
  onLoginClick: () => void;
  onRegisterClick: () => void;
}

const WelcomeScreenTitleBar: React.FC<WelcomeScreenTitleBarProps> = ({
  onLoginClick,
  onRegisterClick,
}) => {
  // Check if running in Electron
  const isElectron = typeof window !== 'undefined' && window.electron !== undefined;

  const handleMinimize = () => {
    // @ts-ignore
    window.electron.ipcRenderer.invoke('window-minimize');
  };

  const handleMaximize = () => {
    // @ts-ignore
    window.electron.ipcRenderer.invoke('window-maximize');
  };

  const handleClose = () => {
    // @ts-ignore
    window.electron.ipcRenderer.invoke('window-close');
  };

  return (
    <div className="welcome-titlebar">
      <div className="titlebar-left">
        <div className="logo">
          <img src="/icon.png" alt="Logo" draggable={false} />
        </div>
        <span className="app-name">Collab</span>
      </div>
      <div className="titlebar-right">
        <WelcomeScreenUserMenu 
          onLoginClick={onLoginClick}
          onRegisterClick={onRegisterClick}
        />
      </div>
      {isElectron && (
        <div className="window-controls">
          <button className="window-control" onClick={handleMinimize} title="Minimize">&#x2014;</button>
          <button className="window-control" onClick={handleMaximize} title="Maximize">&#x2610;</button>
          <button className="window-control close" onClick={handleClose} title="Close">&#x2715;</button>
        </div>
      )}
    </div>
  );
};

export default WelcomeScreenTitleBar;